<template>
<header :class="{'top-header': topHeader}">
  <div class="container">
    <div class="header-content">
      <a class="logo" href="/">
      <img src="@/assets/images/logo.webp" alt="">
    </a>
    <div class="pc-show header-nav">
      <ul>
        <li v-for="item in navList" :key="item.name">
          <a v-if="item.path === '/feedback'" href="javascript:void(0);" @click="showFeedback">
            {{ $t(`${item.meta.title}`) }}
          </a>
          <a v-else :href="item.path">
            {{ $t(`${item.meta.title}`) }}
          </a>
        </li>
      </ul>
      <div class="language">
        <span :class="{'active': $i18n.locale === 'en'}" @click="changeLang('en')">{{$t('navigation.en')}}/EN</span>
        <span :class="{'active': $i18n.locale === 'zh'}" @click="changeLang('zh')">{{$t('navigation.cn')}}/CN</span>
      </div>
    </div>
    <img @click="mobileMenuVisible = true" class="menu-icon mb-show" src="@/assets/icons/menu.svg" alt="">
    </div>
   
  </div>
  <MobileMenu :visible="mobileMenuVisible" @close="mobileMenuVisible = false" />
</header>
</template>

<script>
import MobileMenu from './MobileMenu.vue'
export default {
  components: {
    MobileMenu
  },
  computed: {
    topHeader() {
      return this.$route.path === '/'
    }
  },
  data() {
    return {
      navList: this.$router.options.routes.filter(item => !item.meta.hidden),
      mobileMenuVisible: false
    };
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    },
    showFeedback() {
      this.$bus.$emit('showFeedback');
    }
  }
}
</script>

<style lang='scss' scoped>

.top-header{
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  z-index: 10000;
}

.header-content{
  padding: 19.5px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo img{
    width: 80px;
  }
  .header-nav {
    display: flex;
    align-items: center;
    ul {
      display: flex;
      align-items: center;
      height: 20px;
      li {
        margin-left: 60px;
        a {
          color: #000;
          font-size: 14px;
        }
      }
    }
  }
  .language {
    margin-left: 35px;
    display: flex;
    align-items: center;
    padding: 4px;
    gap: 8px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    span {
      display: inline-block;
      padding: 4px 13px;
      font-size: 12px;
      line-height: 17px;
      border-radius: 2px;
      cursor: pointer;
    }
    .active {
      background: #fff;
      color: #404040;
    }
  }
  .menu-icon {
    width: 16px;
  }
}

@media screen and (max-width: 850px) {
  header {
    .logo img {
      width: 60px;
    }
  }
}
</style>